import { enquireScreen } from "enquire-js";
import React from "react";
import { BecomePartnerModal } from "../../../components/BecomePartnerModal";
import { BusinessConsultModal } from "../../../components/BusinessConsultModal";
import { AppHeader } from "../AppHeader";
import { AppFooter } from "../AppFooter";

interface IPortalPageContainerProps {
  childrenRender?: (props: {
    toggleConsultModalVisible: () => void;
    togglePartnerModalVisible: () => void;
  }) => React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
}

interface IPortalPageContainerState {
  isMobile: boolean;
  partnerModalVisible: boolean;
  consultModalVisible: boolean;
}

let isMobile: boolean;
enquireScreen((b: boolean) => {
  isMobile = b;
});

export class PortalPageContainer extends React.Component<
  IPortalPageContainerProps,
  IPortalPageContainerState
> {
  constructor(props: IPortalPageContainerProps) {
    super(props);
    this.state = {
      isMobile,
      partnerModalVisible: false,
      consultModalVisible: false
    };
  }

  togglePartnerModalVisible = () => {
    const { partnerModalVisible } = this.state;
    this.setState({ partnerModalVisible: !partnerModalVisible });
  };

  toggleConsultModalVisible = () => {
    const { consultModalVisible } = this.state;
    this.setState({ consultModalVisible: !consultModalVisible });
  };

  componentDidMount() {
    enquireScreen(b => {
      this.setState({ isMobile: !!b });
    });
  }

  render() {
    const { header, footer, childrenRender } = this.props;
    const { isMobile, partnerModalVisible, consultModalVisible } = this.state;
    const children = childrenRender
      ? childrenRender({
          togglePartnerModalVisible: this.togglePartnerModalVisible,
          toggleConsultModalVisible: this.toggleConsultModalVisible
        })
      : this.props.children;

    return (
      <div className="PortalPageContainer">
        {header || (
          <AppHeader
            isMobile={isMobile}
            onClickConsult={this.toggleConsultModalVisible}
            onClickPartner={this.togglePartnerModalVisible}
          />
        )}
        {children}
        {footer || <AppFooter />}
        <BecomePartnerModal
          visible={partnerModalVisible}
          onClose={this.togglePartnerModalVisible}
        />
        <BusinessConsultModal
          visible={consultModalVisible}
          onClose={this.toggleConsultModalVisible}
        />
      </div>
    );
  }
}
